import type { AgentTask } from '../types';

interface FolderMembership { id: string; taskIds: string[] }

export function tasksInProjectFolder(tasks: AgentTask[], folders: FolderMembership[], folderId: string): AgentTask[] {
  const folder = folders.find((item) => item.id === folderId);
  if (!folder) return [];
  return tasks.filter((task) => {
    const explicit = folders.find((item) => item.taskIds.includes(task.id));
    return explicit ? explicit.id === folderId : task.project_id === folderId;
  });
}
